jQuery(document).ready(function($) {
 setTimeout( function(){
  
$("a.pd-cp-toggle").attr("aria-label","toggle functionality cookies");
     $("img[src^='//www.civantskincare.com/cdn/shop/t/16/assets/left.png']").attr("alt", "Left arrow");
$("img[src^='//www.civantskincare.com/cdn/shop/t/16/assets/right.png']").attr("alt", "Right arrow");


                       },1500);

 
  let Intervaltime4;
let counter1 = 0; // counter to track the number of times the function is called

try {
    Intervaltime4 = setInterval(GenerateAriaLabelForPopup1, 500);
}
catch (err) {
  
}

function GenerateAriaLabelForPopup1() {
    // Increment the counter each time the function is called
    counter1++;

    // Check if the target element exists
    if (   $("div.junip-customer-container>div[role='img']").length) {
           $("div.junip-customer-container>div[role='img']").each(function() {
        var link = $(this);
        var linkText = link.text();
        console.log(linkText);
        link.empty().append('<span class="bc">' + linkText + '</span>');
  console.log(link);
    }); 
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter1 >= 10) {
        clearInterval(Intervaltime4);
      
    }
}

let Intervaltime3;
let counter = 0; // counter to track the number of times the function is called

try {
    Intervaltime3 = setInterval(GenerateAriaLabelForPopup, 500);
}
catch (err) {
  
}

function GenerateAriaLabelForPopup() {
    // Increment the counter each time the function is called
    counter++;

    // Check if the target element exists
    if (  $("div.pd-cp-cookies-details>a").length) {
         $("div.pd-cp-cookies-details>a").attr("aria-label","toggle performance cookies");
        clearInterval(Intervaltime3);
       //console.log("iframe found");
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter >= 10) {
        clearInterval(Intervaltime3);
      
    }
}
  

  let Intervaltime_google;
let counter_google = 0; // counter to track the number of times the function is called


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
    // Increment the counter each time the function is called
    counter_google++;


    // Check if the target element exists
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');
   $("div.pd-cp-cookies-details>a").attr("aria-labels","toggle performance cookies");
$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
      
        clearInterval(Intervaltime_google);
       
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter_google >= 10) {
        clearInterval(Intervaltime_google);
       
    }
}

  $("a[href='/products/aha-exfoliating-serum']").attr("aria-label", "AHA Exfoliating Serum");
$("a[href='/products/antioxidant-facial-cleanser']").attr("aria-label", "Antioxidant Facial Cleanser");
$("a[href='/products/exfoliating-facial']").attr("aria-label", "Exfoliating Facial");
$("a[href='/products/meladerm']").attr("aria-label", "Meladerm");
$("a[href='/products/purifying-facial-toner']").attr("aria-label", "Purifying Facial Toner");
$("a[href='/products/spf-50-sunscreen']").attr("aria-label", "SPF 50 Sunscreen");
  $("a[href='/products/vitamin-c-serum']").attr("aria-label", "Vitamin C Serum");
$("input[name='q']").attr("aria-label", "Search");
$("input[name='quantity']").attr("aria-label", "Quantity");
$("a[href='/account']").attr("aria-label", "Account");
$("#shopify-section-footer [href='/']").attr("aria-label", "Home Page");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/256x256.png?v=34926848657300942131678962668']").attr("alt", "Check mark icon");
$('input[name="contact_me_by_fax_only"]').attr("aria-label", "checkmark for contact me by fax only");
$('input[name="email"]').attr("aria-label", "Enter your email");
 $('img[src*="chart1_from_magento.jpg"]').attr("alt", "Meladerm Pigment Correction Graph");

$('img[src*="chart2_magento.webp"]').attr("alt", "Reduction of Dark Circles Illustrated Using Graph");

$('img[src*="chart3_magento.webp"]').attr("alt", "Liver Spot Efficacy Test Illustrated Using Graph");
$('a.home-research-link.cta.button').attr("aria-label", "Call to Action Button");

  $(".hs-lazyload").on("load", function() {
     $("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-alpha-arbutin.png?v=175724853393849335791678962664']").attr("alt", "Alpha arbutin ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-azelaic.png?v=149068809921159009341678962663']").attr("alt", "Azelaic acid ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-bearberry.png?v=16086558877150180831678962669']").attr("alt", "Bearberry ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-emblica.png?v=104379263383506966691678962680']").attr("alt", "Emblica ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-kojic.png?v=15947433809021427791678962669']").attr("alt", "Kojic acid ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-lemon.png?v=75149981440856149381678962668']").attr("alt", "Lemon extract ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-licorice.png?v=93317055142731917441678962680']").attr("alt", "Licorice root extract ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-mulberry.png?v=55106434618659863341678962669']").attr("alt", "Mulberry extract ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-niacinamide.png?v=38930104822669331071678962670']").attr("alt", "Niacinamide ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-sepiwhite.png?v=94828092135527651891678962670']").attr("alt", "Sepiwhite ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-symwhite.png?v=181154987332758241601678962667']").attr("alt", "Symwhite ingredient");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-vitamin-c.png?v=42116030871354304721678962670']").attr("alt", "Vitamin C ingredient");
    $("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-ala.png?v=132052516679644884831678962668']").attr("alt", "Close up of Alpha Lipoic Acid");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-argan-oil.png.png?v=119161574792945821781678962668']").attr("alt", "Close up of Argan Oil");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-argireline.png?v=116545368624673437961678962669']").attr("alt", "Close up of Argireline");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-hyaluronic-acid.png.png?v=117695565966834391601678962669']").attr("alt", "Close up of Hyaluronic Acid");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-matrixyl.png?v=57967042388546173971678962670']").attr("alt", "Close up of Matrixyl");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-tocopherol.png?v=144482313475598293381678962669']").attr("alt", "Close up of Tocopherol");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-aloe-vera.png?v=69735486153233261678962681']").attr("alt", "Close up of Aloe Vera");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-pomegranate.png?v=96255656447329100631678962670']").attr("alt", "Close up of Pomegranate");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-phytonadione.png?v=66639240781909032361678962668']").attr("alt", "Close up of Phytonadione");
$("img[src='//www.civantskincare.com/cdn/shop/t/16/assets/ingredient-regu.png?v=54472813742841771481678962667']").attr("alt", "Close up of Regu");

    
$("img[src='//www.civantskincare.com/cdn/shop/files/sepiwhite.png?v=1673218341']").attr("alt", "sepiwhite ");
$("img[src='//www.civantskincare.com/cdn/shop/files/b.png?v=1673217701']").attr("alt", "Niacinamide capsules");
$("img[src='//www.civantskincare.com/cdn/shop/files/pome.png?v=1673217608']").attr("alt", "Pomegranate");
$("img[src='//www.civantskincare.com/cdn/shop/files/aa.png?v=1673218184']").attr("alt", "alpha arbutin");
$("img[src='//www.civantskincare.com/cdn/shop/files/symwhite_377.png?v=1673218381']").attr("alt", "symwhite");
    $("img[src='//www.civantskincare.com/cdn/shop/files/greentea.png?v=1673217953']").attr("alt", "green tea");
$("img[src='//www.civantskincare.com/cdn/shop/files/vitc.png?v=1673217742']").attr("alt", "vitamin c");
$("img[src='//www.civantskincare.com/cdn/shop/files/ginger2x.png?v=1673218018']").attr("alt", "ginger");
$("img[src='//www.civantskincare.com/cdn/shop/files/se.png?v=1673218335']").attr("alt", "sepi white");
$("img[src='//www.civantskincare.com/cdn/shop/files/bamboextract.png?v=1673217185']").attr("alt", "Bamboo Extract");
$("img[src='//www.civantskincare.com/cdn/shop/files/emblicafruitextract_1.png?v=1673217031']").attr("alt", "Emblica Fruit Extract");
$("img[src='//www.civantskincare.com/cdn/shop/files/kojicacid_1.png?v=1673217329']").attr("alt", "Kojic Acid");
$("img[src='//www.civantskincare.com/cdn/shop/files/kojicacid.webp?v=1673217432']").attr("alt", "Kojic Acid");
$("img[src='//www.civantskincare.com/cdn/shop/files/licoriceextract.webp?v=1673217539']").attr("alt", "Licorice Extract");
$("img[src='//www.civantskincare.com/cdn/shop/files/pomegranate.png?v=1673217615']").attr("alt", "Pomegranate");
$("img[src='//www.civantskincare.com/cdn/shop/files/vitaminb3.webp?v=1673217693']").attr("alt", "Vitamin B3");
$("img[src='//www.civantskincare.com/cdn/shop/files/vitaminc.webp?v=1673217735']").attr("alt", "Vitamin C");
$("img[src='//www.civantskincare.com/cdn/shop/files/mulberryroot.webp?v=1673217801']").attr("alt", "Mulberry Root");
$("img[src='//www.civantskincare.com/cdn/shop/files/gingerrot.png?v=1673217998']").attr("alt", "Ginger Root");
$("img[src='//www.civantskincare.com/cdn/shop/files/alpha_arbutin.webp?v=1673218189']").attr("alt", "Alpha Arbutin");
$("img[src='//www.civantskincare.com/cdn/shop/files/azelaic_acid.webp?v=1673218234']").attr("alt", "Azelaic Acid");
$("img[src='//www.civantskincare.com/cdn/shop/files/seabuckthornfruit.png?v=1673217834']").attr("alt", "Sea Buckthorn Fruit");
$("img[src='//www.civantskincare.com/cdn/shop/files/almondextract.png?v=1673218039']").attr("alt", "Almond Extract");
$("img[src='//www.civantskincare.com/cdn/shop/files/argireline.png?v=1673218105']").attr("alt", "Argireline");
$('img[src^="//www.civantskincare.com/cdn/shop/files/civant-real-stories-mobile.jpg?v=1677779559?format=webp"]').attr("alt", "Civant Real Stories Mobile Image");
setTimeout(function(){},1000)


$("img[src*='ingredient']").each(function() {
    var src = $(this).attr("src");
    var altText = src.match(/ingredient-(.*?).png/);
    if (altText && altText.length > 1) {
        $(this).attr("alt", "Close up of " + altText[1].replace(/-/g, ' '));
    }
});
$("img[src*='after']").each(function() {
    var src = $(this).attr("src");
    var altText = "After image";
    if (altText && altText.length > 1) {
        $(this).attr("alt", altText);
    }
});
    $("img[src*='before']").each(function() {
    var src = $(this).attr("src");
    var altText = "Before image";
    if (altText && altText.length > 1) {
        $(this).attr("alt", altText);
    }
});
    });
  
$("img[src='//www.civantskincare.com/cdn/shop/files/1_bf61eb96-3930-4fe0-b6a0-995e06b628d9.jpg?crop=center&height=612&v=1696273626']").attr("alt", "Before and after image");

$("h2:empty").append("<span style='display:none'>.</span>")
$("a.article-image-link").attr("aria-label","blog post link");

  console.log( "ready!" );
});


$(window).on('load', function() {

  setTimeout(function(){$("img.fotorama__img").each(function() {
        if (!$(this).attr("alt") || $(this).attr("alt").trim() === "") {
            $(this).attr("alt", "product images");
        }
    });
/*
                        $('img[src="//www.civantskincare.com/cdn/shop/files/j1.jpg?v=1674154599&amp;width=499"]').attr("alt", "Before Image");
$('img[src="//www.civantskincare.com/cdn/shop/files/j2.jpg?v=1674154599&amp;width=499"]').attr("alt", "After Image");

$('img[src="//www.civantskincare.com/cdn/shop/files/1.jpg?v=1674154671&amp;width=499"]').attr("alt", "Before Image");
$('img[src="//www.civantskincare.com/cdn/shop/files/2.jpg?v=1674154671&amp;width=499"]').attr("alt", "After Image");

$('img[src="//www.civantskincare.com/cdn/shop/files/b.jpg-rsbiid-169.jpg?v=1674155088&amp;width=96"]').attr("alt", "Before Image");
$('img[src="//www.civantskincare.com/cdn/shop/files/a.jpg-rsaiid-169.jpg?v=1674155088&amp;width=96"]').attr("alt", "After Image");

$('img[src="//www.civantskincare.com/cdn/shop/files/b.jpg-rsbiid-31.jpg?v=1674155285&amp;width=96"]').attr("alt", "Before Image");
$('img[src="//www.civantskincare.com/cdn/shop/files/a.jpg-rsaiid-31.jpg?v=1674155286&amp;width=96"]').attr("alt", "After Image");

$('img[src="//www.civantskincare.com/cdn/shop/files/b.jpg?v=1674155150&amp;width=96"]').attr("alt", "Before Image");
$('img[src="//www.civantskincare.com/cdn/shop/files/a.jpg?v=1674155151&amp;width=96"]').attr("alt", "After Image");

$('img[src="//www.civantskincare.com/cdn/shop/files/b.jpg-rsbiid-27.jpg?v=1674155342&amp;width=96"]').attr("alt", "Before Image");
$('img[src="//www.civantskincare.com/cdn/shop/files/a.jpg-rsaiid-27.jpg?v=1674155342&amp;width=96"]').attr("alt", "After Image");

$('img[src="//www.civantskincare.com/cdn/shop/files/a.jpg-rsaiid-43.jpg?v=1674155212&amp;width=96"]').attr("alt", "Before Image");
$('img[src="//www.civantskincare.com/cdn/shop/files/b.jpg-rsbiid-43.jpg?v=1674155212&amp;width=96"]').attr("alt", "After Image");
*/
               /*      
             $("div.junip-customer-container>div").each(function() {
        var link = $(this);
        var linkText = link.text();
        console.log(linkText);
        link.empty().append('<span class="bc">' + linkText + '</span>');
  console.log(link);
    });          
                        */
                       },1000)

  $("button.close-all-ingredients").append("<span style='display:none'>.</span>");
});

